import PageviewIcon from '@mui/icons-material/Pageview';
import {
  IconButton
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import TableGridWithFilters from '../../components/TablegridWithFilters/TableGridWithFilters/TableGridWithFilters';
import { FieldControllerTypes } from '../../components/form_v2/types';
import { queueMapper } from './static/applicationMappers';

const filterFields = [
  [
    {
      control: FieldControllerTypes.autocomplete,
      type: 'search',
      name: 'queuetype',
      label: 'Κατηγορία',
      filtersDesign: true,
      options: Object.keys(queueMapper).map(queue => {
        return { 
          key: queueMapper[queue],
          value: queue
        };
      })
    }
  ],
];

const columns = (): GridColDef[] => {
  const navigate = useNavigate();
  return [
    {
      field: 'application_code',
      headerName: 'Κωδικός Αίτησης',
      flex: 0.4,
      sortable: false,
    },
    {
      field: 'queuetype',
      headerName: 'Μη Ολοκληρωμένες Κατηγορίες Αίτησης',
      flex: 1,
      sortable: false,
      renderCell: ({row}) => row.queuetype.split(',').map((x: string) => queueMapper[x]).join(', ') || '-'
    },
    {
      field: 'actions',
      headerName: '',
      headerAlign: 'center',
      sortable: false,
      flex: 0.2,
      align: 'center',
      renderCell: ({ row }: any) => {
        return <IconButton
          color='primary'
          onClick={() => navigate(`/admin/settings/edit-applications?appl_code=${row.application_code}`)}
        >
          <PageviewIcon />
        </IconButton>;
      },
    },
  ];
};

const SearchApplications = () => {
  document.title = 'Μη Ολοκληρωμένες Αιτήσεις';
  return (
    <>
      <TableGridWithFilters
        fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/applications-pske`}
        columns={columns()}
        initialValues={{ category: '' }}
        filterFields={filterFields}
        paginationMode='server'
        oneLiner
      />
    </>
  );
};

export default SearchApplications;